import { render } from "./ItemIndexPassTile.vue?vue&type=template&id=4faff9ea&scoped=true"
import script from "./ItemIndexPassTile.vue?vue&type=script&lang=js"
export * from "./ItemIndexPassTile.vue?vue&type=script&lang=js"

import "./ItemIndexPassTile.vue?vue&type=style&index=0&id=4faff9ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4faff9ea"

export default script